<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Отчет по договорам"
      link="components/data-tables"
    />

    <base-material-card
      color="primary"
      icon="mdi-file-document"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Отчет по договорам
        </div>
      </template>

      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        multi-sort
        :footerProps="datatable_footer"
      >
       <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
        {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
        </template>
        <template v-slot:top>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date.from"
                    label="Дата начала"
                    type="date"
                    @keyup.enter="load(false)"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date.to"
                    label="Дата конца"
                    type="date"
                    @keyup.enter="load(false)"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.number"
                    label="Номер договора"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    min-width="150"
                    @click="load(false)"
                  >
                    Показать
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    min-width="250"
                    @click="load(true, 1)"
                  >
                    Выгрузить отчет по договорам
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    min-width="250"
                    @click="load(true, 2)"
                  >
                    Выгрузить сводный отчет
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:item.sum_final="{item}">
          <v-chip
            v-if="item.sum_final>0"
            color="green"
            dark
          >
            {{ item.sum_final }}
          </v-chip>
          <v-chip
            v-else
            color="red"
            dark
          >
            {{ item.sum_final }}
          </v-chip>
        </template>
        <template v-slot:item.number="{item}">
          <a @click="$router.push('/contract/list?id=' + item.id)">{{ item.number }}/{{ format_contract_date(item.date) }}</a>
        </template>
        <template v-slot:item.date="{item}">
          {{ format(item.date) }}
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    name: 'DashboardDataTables',
    data: () => ({
      datatable_footer: {
        itemsPerPageAllText: 'Все',
        itemsPerPageText: 'Показывать по', pageText: 'из'
      },
      headers: [
        {
          text: 'Дата договора',
          value: 'date',
        },
        {
          text: 'Номер договора',
          value: 'number',
        },
        {
          text: 'Сумма выплаты от СК',
          value: 'sum_insurer',
        },
        {
          text: 'Сумма по договору цессии',
          value: 'sum_client',
        },
        {
          text: 'Сумма выплаты по Этапу 1',
          value: 'sum_stage1',
        },
        {
          text: 'Сумма выплаты по Этапу 2',
          value: 'sum_stage2',
        },
        {
          text: 'Сумма выплаты по Этапу 3',
          value: 'sum_stage3',
        },
        {
          text: 'Прочие выплаты',
          value: 'sum_other_out',
        },
        {
          text: 'Прочие доходы',
          value: 'sum_other_in',
        },
        {
          text: 'Финансовый результат',
          value: 'sum_final',
        },
      ],
      items: [],
      search: undefined,
      form: {
        transactions: true,
        date: {
          from: '',
          to: '',
        },
        kind: 0,
        state: 5,
      },
      select: {
        state: [
          { value: 1, text: 'Новый' },
          { value: 2, text: 'Осмотр назначен' },
          { value: 3, text: 'Осмотр проведен' },
          { value: 4, text: 'Документы сданы в СК' },
          { value: 5, text: 'Выплата согласована СК' },
          { value: 6, text: 'Деньги получены от СК' },
          { value: 7, text: 'Передано в архив' },
          { value: 8, text: 'Удален' },
          { value: 9, text: 'Ремонт завершен' },
          { value: 10, text: 'Расторгнут'}
        ],
        kind: [
          { value: 1, text: 'Оформление документов' },
          { value: 2, text: 'Договор Цессии' },
        ],
      },
      dict: {
        state: {
          1: 'Новый',
          2: 'Осмотр назначен',
          3: 'Осмотр проведен',
          4: 'Документы сданы в СК',
          5: 'Выплата согласована СК',
          6: 'Деньги получены от СК',
          7: 'Передано в архив',
          8: 'Удален',
          9: 'Ремонт завершен',
          10: 'Расторгнут'
        },
        kind: {
          1: 'Оформление документов',
          2: 'Договор Цессии',
        },
        type: {},
      },
    }),
    mounted: function () {
      this.load()
      this.form.date.from = moment().format('YYYY-MM-DD')
      this.form.date.to = moment().format('YYYY-MM-DD')
      for (let x in this.$store.state.dict.transaction_type) {
        this.dict.type[this.$store.state.dict.transaction_type[x].key] = x
      }
    },
    methods: {
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_contract_date: function (date) {
        return moment(date).format('DDMM')
      },
      load: function (exp, number) {
        if (exp) {
          let form = $('<form>', {
            target: '_blank',
            action: '/api/contract/report/' + number,
            method: 'post',
          })
          form.append(
            $('<input>', {
              type: 'hidden',
              value: JSON.stringify(this.form),
              name: 'form',
            })
          )
          form.appendTo('body').submit()
        } else {
          this.axios.post('/api/contract/get', this.form)
            .then(result => {
              if (!result.data.error) {
                for (let x in result.data.data) {
                  result.data.data[x].sum_insurer = Number(result.data.data[x].transactions.filter(a => a.type == this.dict.type['insurer']).reduce(
                    (a, b) => {
                      var sum = a
                      if (b.payments!=null) {
                        for (let x in b.payments) {
                          sum += b.payments[x].sum
                        }
                      }
                      return sum
                    }
                    , 0
                  ))
                  result.data.data[x].sum_client = Number(result.data.data[x].transactions.filter(a => a.type == this.dict.type['client']).reduce(
                    (a, b) => {
                      var sum = a || 0
                      console.log(b)
                      if (b.payments!=null) {
                        for (let x in b.payments) {
                          
                          sum += b.payments[x].sum
                        }
                      }
                      return sum || 0
                    }
                    , 0))
                  result.data.data[x].sum_stage1 = Number(result.data.data[x].transactions.filter(a => a.type == this.dict.type['stage1']).reduce((a, b) => a + b.sum, 0))
                  result.data.data[x].sum_stage2 = Number(result.data.data[x].transactions.filter(a => a.type == this.dict.type['stage2']).reduce((a, b) => a + b.sum, 0))
                  result.data.data[x].sum_stage3 = Number(result.data.data[x].transactions.filter(a => a.type == this.dict.type['stage3']).reduce((a, b) => a + b.sum, 0))
                  result.data.data[x].sum_other_in = Number(result.data.data[x].transactions
                    .filter(a => a.direction == 1 && a.type != this.dict.type['stage3'] && a.type != this.dict.type['stage2'] && a.type != this.dict.type['stage1'] && a.type != this.dict.type['client'] && a.type != this.dict.type['insurer'] &&  a.type != this.dict.type['service'])
                    .reduce((a, b) => 
                    {
                       var sum = a || 0
                      console.log(b)
                      if (b.payments!=null) {
                        for (let x in b.payments) {
                          
                          sum += b.payments[x].sum
                        }
                      }
                      return sum || 0
                    }
                    , 0))
                  result.data.data[x].sum_other_out = Number(result.data.data[x].transactions
                    .filter(a => a.direction == 2 && a.type != this.dict.type['stage3'] && a.type != this.dict.type['stage2'] && a.type != this.dict.type['stage1'] && a.type != this.dict.type['client'] && a.type != this.dict.type['insurer'] && a.type != this.dict.type['service'])
                    .reduce((a, b) => 
                    {
                       var sum = a || 0
                      console.log(b)
                      if (b.payments!=null) {
                        for (let x in b.payments) {
                          
                          sum += b.payments[x].sum
                        }
                      }
                      return sum || 0
                    }
                    , 0))
                  console.log(result.data.data[x].sum_insurer, result.data.data[x].sum_stage1, result.data.data[x].sum_stage2, result.data.data[x].sum_stage3, result.data.data[x].sum_other_in, result.data.data[x].sum_other_out)
                  result.data.data[x].sum_final = Number((result.data.data[x].sum_insurer + result.data.data[x].sum_other_in) - (result.data.data[x].sum_client + result.data.data[x].sum_stage1 + result.data.data[x].sum_stage2 + result.data.data[x].sum_stage3 + result.data.data[x].sum_other_out)).toFixed(2)
                }
                this.items = result.data.data
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', 'Ошибка при получении данных')
            })
        }
      },
    },
  }
</script>
